module.exports = __webpack_public_path__ + "img/es-ce.d61c3d24.svg";